import { useMutation, useQuery } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import { kbApi } from '@/services/api/knowledge-base';
import type { KBArticleDetail, KBChatResponse } from '@/services/api/knowledge-base';

export const useKBArticles = (route?: string) => {
  const location = useLocation();
  const currentRoute = route || location.pathname;

  return useQuery({
    queryKey: ['kb-articles', currentRoute],
    queryFn: () => kbApi.getArticles(currentRoute),
    staleTime: 10 * 60 * 1000, // 10 min
    enabled: !!currentRoute,
  });
};

export const useKBArticle = (id: number | null) => {
  return useQuery<KBArticleDetail>({
    queryKey: ['kb-article', id],
    queryFn: () => kbApi.getArticle(id!),
    enabled: id !== null,
  });
};

export const useKBChat = () => {
  return useMutation<KBChatResponse, Error, { question: string; route: string; labels?: string[]; language?: string }>({
    mutationFn: ({ question, route, labels, language }) => kbApi.chat(question, route, labels, language),
  });
};

export const useCurrentRouteLabels = () => {
  const { data } = useKBArticles();
  return data?.labels || [];
};
